import { useDispatch } from 'react-redux';
import { setDataObject as setInvoice } from '@redux/ducks/invoice';
import { ViewFile } from '@components';

export default function DevolutionDetailComponent(props) {
  const dispatch = useDispatch();
  const { item } = props;
  const detailInvoice = invoiceNo => {
    dispatch(
      setInvoice({
        key: invoiceNo,
      })
    );
  };

  return (
    <>
      <div
        className={`${
          item.status === 'REALIZED'
            ? 'text-teal-700 bg-teal-100'
            : 'text-red-700 bg-red-100'
        } inline-block items-center rounded-md px-2 py-1 text-xs font-medium`}
      >
        {item.status === 'REALIZED' ? 'Efetivado' : 'Pendente'}
      </div>

      <div className="px-2 py-2 sm:grid sm:grid-cols-2 sm:gap-2 sm:px-0">
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Nota Fiscal: </b>
          <span
            className="text-blue-500 cursor-pointer"
            onClick={() => {
              detailInvoice(item.invoice.invoiceNo);
            }}
          >
            {item.invoice && item.invoice.invoiceNo}
          </span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Cliente: </b>
          <span>
            {item.invoice &&
              `${item.invoice.customer.corporateName} (${item.invoice.customer.code})`}
          </span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Chave da nota fiscal: </b>
          <span>{item?.invoice?.key}</span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Motivo devolução: </b>
          <span>{item.reason && item.reason.description}</span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Transportadora: </b>
          <span>
            {item.invoice &&
              item.invoice.dispatcher &&
              `${item.invoice.dispatcher.company.corporateName}`}
          </span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Frete da Empresa: </b>
          <span>
            {item.charges && item.charges.freightForCompany ? 'Sim' : 'Não'}
          </span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Cobra frete do representante: </b>
          <span>
            {item.charges && item.charges.representativeFreight ? 'Sim' : 'Não'}
          </span>
        </div>
        <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
          <b>Cobra ST do Representante: </b>
          <span>
            {item.charges && item.charges.representativeTaxSubstitution
              ? 'Sim'
              : 'Não'}
          </span>
        </div>
      </div>

      {item.status === 'REALIZED' && (
        <div className="px-2 py-2 sm:grid sm:grid-cols-2 sm:gap-2 sm:px-0">
          <div className="mt-1 text-sm leading-6 text-gray-900 sm:mt-0">
            <b>Número do BD / Nota fiscal do cliente: </b>
            <span>{item.bdNumber}</span>
          </div>
        </div>
      )}
      <div className="text-sm leading-6 text-gray-900">
        <b>Observação: </b>
        <span>{item.note}</span>
      </div>

      {item.customerDocument && (
        <div className="mt-4">
          <ViewFile url={item.customerDocument} />
        </div>
      )}
    </>
  );
}
